import { AnimatePresence, motion } from 'framer-motion';

interface TaggedDocumentsProps {
  taggedDocuments: { doc_id: string; file_name: string }[];
}

export function TaggedDocuments({ taggedDocuments }: TaggedDocumentsProps) {
  return (
    <AnimatePresence>
      {taggedDocuments.length > 0 && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
          className="space-y-2"
        >
          <div className="scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent max-h-32 overflow-y-auto">
            <ul className="space-y-1.5">
              {taggedDocuments.map((doc, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.05, duration: 0.2 }}
                  className="flex items-start gap-2 rounded-md bg-gray-50/80 p-2 text-xs text-gray-600 transition-colors hover:bg-gray-100/80"
                >
                  <span className="iconify lucide--file-text mt-0.5 flex-shrink-0 text-gray-400"></span>
                  <span className="truncate leading-relaxed">
                    {doc.file_name.length > 35 ? `${doc.file_name.substring(0, 35)}...` : doc.file_name}
                  </span>
                </motion.li>
              ))}
            </ul>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
